<template>
  <div class="list-wrap goodslist">

    <el-row class="list-table-wrap">
      <el-row v-show="dataList.tableTopCon" class="list-table-top">
        <el-col class="list-table-top-wrap" :span="5">
          <el-dropdown size="mini">
            <span class="el-dropdown-link">
              {{searchTypeLable}}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item) in searchTypeOptions" :key="item.value" @click.native="searchTypeChange(item.value)">{{item.lable}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-input class="list-table-top-orderId" v-model="searchTypeInp" :placeholder="searchTypeInpPh"></el-input>
        </el-col>
        <el-col class="list-table-top-wrap" :span="8">
          创建时间：
          <el-date-picker v-model="searchTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col class="list-table-top-wrap list-table-top-wrap-btns" :span="11">
          <div class="list-table-top-wrap-l">
            <el-button class="list-table-top-btn-clear" @click="clear">清空条件</el-button>
            <el-button type="primary" round @click="search">搜索</el-button>
            <el-button class="btn-isexport" round @click="exportList">导出</el-button>
            <el-button class="list-table-top-btn-clear list-table-top-btn-refresh" @click="search"><i class="el-icon-refresh-right"></i></el-button>
          </div>
          <div class="list-table-top-wrap-r">
            <!-- <el-button type="primary" round @click="addActive">添加活动</el-button> -->
            <el-button type="warning" round v-if="rolesApi.indexOf('api_products_create_products')>=0" @click="onsale">发布商品</el-button>
          </div>
        </el-col>

      </el-row>
      <el-row class="list-table-con">
        <el-table ref="multipleTable" v-loading="tableLoading" lazy row-key='orderId' :data="listData.data" tooltip-effect="dark" empty-text="暂无数据哦～" style="width: 100%" @selection-change="handleSelectionChange" @sort-change="goodsSort" :expand-row-keys="expands" :row-class-name="tableRowClassName">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="id" sortable='custom' label="商品编号" width="100"></el-table-column>
          <el-table-column label="缩略图" width="80">
            <template slot-scope="scope">
              <img class="goods-img" :src="$url(scope.row.product_thumb)" alt="">
            </template>
          </el-table-column>

          <el-table-column class="goods-name-td" label="商品名称" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.product_name}}
            </template>
          </el-table-column>
          <el-table-column prop="category_name" label="商品类别" width="80"></el-table-column>
          <el-table-column prop="market_price" sortable='custom' label="市场价格" width="100">
            <template slot-scope="scope">
              ￥{{scope.row.market_price}}
            </template>
          </el-table-column>
          <el-table-column prop="shop_price" sortable='custom' label="当前价格" width="100">
            <template slot-scope="scope">
              ￥{{scope.row.shop_price}}
            </template>
          </el-table-column>
          <el-table-column prop="created_at" sortable='custom' label="创建时间" width="140"></el-table-column>
          <el-table-column prop="product_number" sortable='custom' label="库存" width="80"></el-table-column>
          <el-table-column prop="sale_quantity" sortable='custom' label="销量" width="80"></el-table-column>
          <el-table-column align="center" label="上架" v-if="rolesApi.indexOf('api_products_update_sale')>=0" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_on_sale" :active-value=1 :inactive-value=0 active-color="#2E71FE" inactive-color="#F6F8FB" @click.native="handleSwitch(scope.$index, scope.row)"></el-switch><span class="switch-text">{{scope.row.is_on_sale==1?"开":"关"}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="160">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="rolesApi.indexOf('api_products_update_products')>=0" @click="handleDetial(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" class="table-attr-btn" v-if="rolesApi.indexOf('api_products_delete_products')>=0" @click="handleDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :key="updataPage" v-if="page.total" :page-count="page.count" :current-page="page.current_page" :total-page="page.total_pages" :page-size="page.per_page" :total="page.total" background layout="prev, pager, next, total" @current-change="handleCurrentChange">
        </el-pagination>

      </el-row>
    </el-row>
  </div>
</template>

<script>
import popDetail from "@/components/popover/popDetail.vue";

export default {
  props: ["dataList", "pagination", "searchParams"],
  data () {
    return {
      multipleSelection: [],
      expands: [],

      //筛选
      search_type: 0,
      searchTypeLable: "商品名称",
      searchTypeInp: "",
      searchTypeInpPh: "请输入商品名称",
      searchTypeOptions: [
        {
          lable: "商品名称",
          value: 0
        }
      ],
      searchTime: "",
      time_start: "",
      time_end: "",
      //筛选的导出
      is_export: "0",

      // showPopDetail: false,
      orderIdPopDetail: "",

      listData: this.dataList,

      // 页码
      updataPage: "",
      page: this.pagination,
      // 排序参数, 默认按创建时间倒序
      order_type: '6',
      sort_order: 'desc',

    };
  },
  created () {
  },
  watch: {
    searchTime () {
      let time = this.searchTime;
      if (time != "") {
        this.time_start = this.ut.formatTime(time[0], "str");
        this.time_end = this.ut.formatTime(time[1], "str");
        // console.log(this.time_start);
      }
    }
  },
  computed: {
    tableLoading: {
      get: function () {
        return this.$store.state.tableLoading;
      },
      set: function () { }
    },
    rolesApi: {
      get: function () {
        return this.$store.state.rolesApi;
      },
      set: function () { }
    }
  },
  methods: {
    clear () {
      //清空参数
      this.searchTypeInp = "";
      this.searchTime = "";
      this.time_start = "";
      this.time_end = "";
    },
    searchTypeChange (val) {
      this.search_type = val;
    },
    search () {
      this.getlist({
        sale: this.searchParams.sale,
        type: this.searchParams.type || 'normal',  // 默认设置为普通类型
        name: this.searchTypeInp,
        start: this.time_start,
        end: this.time_end,
        order: this.order_type,
        sorted: this.sort_order
      });

      //更新组件
      this.updataPage = new Date().getTime();
      // 更新父组件红点统计count接口
      this.$emit("updataCount")
    },
    //编辑
    handleDetial (index, row) {
      // 先清空editGoods状态再重新设置，确保状态纯净
      this.$store.dispatch("setEditGoods", '');
      this.$store.dispatch("setEditGoods", row.id);

      this.$store.dispatch("addHeadTab", {
        addTitle: "编辑商品",
        addUrl: "edit-goods"
      });
    },
    handleSwitch (index, row) {
      // console.log('row', row.id)
      let status = row.is_on_sale;
      this.$axios.post(`/api/v1/sale/${row.id}`).then(res => {
        if (res.data.status == "200") {
          if (status === 0) {
            status = 1;
          } else {
            status = 0;
          }
          this.$popup(res.data.msg, "success");
          // 列表页刷新
          this.search();
        } else {
          this.$popup(res.data.msg, "error");
          this.listData.data.forEach((item) => {
            if (item.id === row.id) {
              item.is_on_sale = item.is_on_sale === 1 ? 0 : 1;
            }
          });
        }
      });
    },
    handleDelete (index, row) {
      this.$confirm("确定删除此商品吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios.post(`/api/v1/products/del/${row.id}`).then(res => {
          if (res.data.status == "200") {
            this.listData.data.splice(index, 1);
            this.$popup("删除成功", "success");
          } else {
            this.$popup(res.data.msg, "error");
          }
          // 列表页刷新
          this.search();
        });
      })
    },
    //发布商品
    onsale () {
      this.$store.dispatch("addHeadTab", {
        addTitle: "发布商品",
        addUrl: "add-goods"
      });
    },
    //列表排序
    goodsSort (a) {
      let sortType;
      let sortOrder = a.order == "descending" ? "desc" : "asc";
      switch (a.prop) {
        case "id":
          sortType = 1;
          break;
        case "market_price":
          sortType = 2;
          break;
        case "shop_price":
          sortType = 3;
          break;
        case "product_number":
          sortType = 4;
          break;
        case "sale_quantity":
          sortType = 5;
          break;
        case "created_at":
          sortType = 6;
          break;
        default:
          break;
      }
      this.order_type = sortType;
      this.sort_order = sortOrder;
      this.search();
    },
    //页码切换
    handleCurrentChange (page) {
      this.getlist({
        sale: this.searchParams.sale,
        type: this.searchParams.type || 'normal',  // 默认设置为普通类型
        name: this.searchTypeInp,
        start: this.time_start,
        end: this.time_end,
        order: this.order_type,
        sorted: this.sort_order,
        page: page
      });
    },
    getlist (a) {
      // 确保type参数始终存在，默认为normal
      if (!a.type) {
        a.type = 'normal';
      }
      
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/products", {
          params: a
        })
        .then(res => {
          if (res.data.status == "200") {
            this.listData.data = res.data.data;
            //获取页码数据
            this.page = res.data.meta.pagination
          } else {
            this.$popup(res.data.msg, "error");
          }
          this.$store.dispatch("setTableLoading", false);
        });
    },
    exportList () {
      let exportParam = {
        sale: this.searchParams.sale,
        type: this.searchParams.type || 'normal',  // 默认设置为普通类型
        name: this.searchTypeInp,
        start: this.time_start,
        end: this.time_end,
        excel: "1"
      };
      if (!this.time_start || !this.time_end) {
        delete exportParam.start_time;
        delete exportParam.end_time;
      }
      if (this.searchTypeInp != "") {
        exportParam.search_value = this.searchTypeInp;
      }
      this.$axios({
        method: "GET",
        url: "/api/v1/products",
        params: exportParam,
        responseType: "blob"
      }).then(res => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = URL.createObjectURL(blob);
        window.location.href = url;
      });
    },
    handleSelectionChange () { },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "row-white";
      } else if (rowIndex % 2 === 0) {
        return "row-grey";
      }
      return "";
    },
    openLine (row) {
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };

      if (this.expands.indexOf(row.orderId) < 0) {
        this.expands.push(row.orderId);
      } else {
        this.expands.remove(row.orderId);
      }
    }
  },
  components: {
    popDetail
  }
};
</script>
<style lang="less">
.list-wrap {
  height: calc(100vh - 235px);
  .el-button {
    width: 72px;
    height: 34px;
    padding: 0;
    margin: 0 10px;
    &:hover {
      color: inherit;
    }
    &.el-button--primary {
      background-color: #2e71fe;
      border: 1px solid #2e71fe;
    }
    &.el-button--warning {
      background-color: #ff6529;
      border: 1px solid #ff6529;
    }
    &.el-button--default {
      font-size: 12px;
      color: #2e71fe;
      border: 1px solid #2e71fe;
    }
  }
  .list-table-wrap .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  //滚动条的滑块
  .list-table-wrap .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #c5c5c5;
    border-radius: 3px;
  }
  .list-table-wrap {
    min-width: 1112px;
    height: 100%;
    .list-table-top {
      height: 82px;
      padding-top: 20px;
      padding-left: 32px;
      font-size: 12px;
      color: #081234;
      background-color: #ffffff;
      .list-table-top-wrap {
        .list-table-top-wrap-l {
          float: left;
          text-align: left;
        }
        .list-table-top-wrap-r {
          float: right;
          text-align: right;
          padding-top: 2px;
          .el-button {
            margin-right: 22px;
          }
        }
      }
      .el-input__inner {
        border: none;
        border-radius: 0;
        background-color: #f6f8fb;
      }
      .el-date-editor .el-range-input {
        background-color: #f6f8fb;
        // width: 40%;
      }
      .el-date-editor .el-range-separator {
        height: 40px;
        line-height: 40px;
        background-color: #ffffff;
      }
      .el-date-editor--datetimerange.el-input__inner {
        width: 70%;
      }
      .list-table-top-orderId {
        width: 60%;
        height: 42px;
      }
      .list-table-top-btn-clear {
        width: 60px;
        height: 34px;
        border: none;
        background-color: transparent;
        color: #2e71fe;
        i {
          position: relative;
          top: 4px;
          font-size: 20px;
          color: #081234;
        }
      }
      .list-table-top-btn-refresh {
        width: 34px;
      }
    }
    .list-table-con {
      position: relative;
      height: calc(100% - 82px);
      .el-table {
        position: relative;
        height: calc(100% - 120px);
        font-size: 12px;
        .el-table__header-wrapper {
          position: absolute;
          top: 0;
        }
        .el-table__body-wrapper {
          position: absolute;
          top: 59px;
          height: calc(100% - 59px);
          overflow-y: scroll;
        }
        .el-badge__content {
          height: 14px;
          line-height: 8px;
          padding: 0 5px;
          background-color: #ff6529;
          cursor: pointer;
        }
        .el-badge__content.is-fixed {
          top: 50%;
          right: 0;
        }
        .el-button {
          margin: 0;
        }
        .el-button.is-focus {
          color: #ffffff;
        }
        .el-button.el-button--default {
          background-color: transparent;
          border: none;
        }
        .goods-img {
          width: 32px;
          height: 32px;
          vertical-align: top;
        }
        .table-attr-btn {
          display: inline-block;
          width: 44px;
          height: 24px;
        }
        .el-button.el-button--primary {
          width: 44px;
          height: 24px;
          border-radius: 12px;
          border: none;
        }
        .el-icon-caret-bottom {
          display: inline-block;
          padding: 6px;
          color: #2e71fe;
        }
        .cell .switch-text {
          position: relative;
          top: 1px;
          display: inline-block;
          margin-left: 6px;
          font-size: 12px;
        }
      }
      .el-table .row-white {
        background: #ffffff;
      }
      .el-table .row-grey {
        background: #fafcff;
      }
      .el-table .cell {
        text-align: center;
      }
      .goods-name-td {
        padding: 0 10px;
      }
      .el-pagination {
        // position: absolute;
        // left: 50%;
        bottom: 60px;
        // transform: translateX(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list/goodslist.vue